<template>
    <div class="d-search-user" @click.stop>
        <img class="triangle" src="../../images/top-v.png">
        <div class="search-content">
            <div class="input-wrap">
                <div class="search-icon"></div>
                <input
                    class="search-input"
                    type="text"
                    placeholder="搜索用户昵称"
                    id="searchInput"
                    v-model="searchValue"
                    @input="onInput"
                    @focus="onFocus"
                >
                <div class="delete-icon" @click="deleteValue"></div>
            </div>
            <ul class="user-list">
                <li
                    class="user-item"
                    v-for="(item, index) in searchData"
                    :key="index"
                    @click="selectUser(item)"
                >
                    <div class="avatar">
                        <img :src="setPicSize(item.avatar || defaultAvatar, 48, 48)" alt="">
                    </div>
                    <div class="user-content">
                        <div class="name" v-html="replaceValue(item.nickname)"></div>
                        <span class="tag" v-if="item.type == 1">作者</span>
                    </div>
                </li>

                <div class="noData" v-if="!searchData.length && !loading">
                    <div class="empty-cover"></div>
                    <div class="text">请搜索查找用户</div>
                </div>
            </ul>
        </div>
    </div>
</template>

<script>
import { getAtUserList } from "@/request/commentApi";
import { sendSpmAction, setPicSize } from "mpfe-utils";

const acodeMap = {
    close: 11115,
    focus: 11116,
    delete: 11117,
    select: 11118
}

export default {
    name: 'DialogSearchUser',
    props: {
        articleId: {
            type: String,
            default: ''
        },
        accountId: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            searchValue: '',
            searchData: [],
            loading: false,
            defaultAvatar: 'https://c1494161c414f.cdn.sohucs.com/user-profilephoto/merged-photo/20.jpg',
        }
    },
    methods: {
        setPicSize,
        deleteValue() {
            this.searchValue = ''
            this.searchData = [];
            this.sendAction(acodeMap.delete);
        },
        selectUser(item) {
            this.sendAction(acodeMap.select);
            this.$emit('selectUser', item)
        },
        replaceValue(text) {
            if (!text) return '';
            return text.replace(this.searchValue, `<span class="red-text">${this.searchValue}</span>`)
        },
        onFocus() {
            this.sendAction(acodeMap.focus);
        },
        onInput() {
            if (!this.timer) {
                this.timer = setTimeout(() => {
                    this.searchUser();
                    this.timer = null;
                }, 300)
            }
        },
        async searchUser() {
            if (!this.searchValue) {
                this.searchData = [];
                return;
            }
            if (this.loading) return;
            this.loading = true;

            const param = {
                prefix: this.searchValue,
                authorId: this.accountId,
                sourceId: `mp_${this.articleId}`,
                pageNo: 1,
                size: 20
            }
            try {
                const { code, data } = await getAtUserList(param)
                if (code === 200) {
                    this.searchData = data || [];
                }
            } catch (error) {
                console.log('获取艾特用户列表错误', error)
            } finally {
                this.loading = false
            }
        },
        sendAction(acode) {
            if (!acode) return;
            const clkParam = `sourceId:mp_${this.articleId};authorId:${this.accountId};url:${location.href}`
            sendSpmAction(
                acode,
                clkParam
            )
        },
        hide(event){

            this.$emit('hide', false)
            this.sendAction(acodeMap.close);
        },
        listenEvent(){
            this.$nextTick(() => {
                document.querySelector('body').addEventListener('click',this.hide)
            })
        },
        removeEvent(){
            document.querySelector('body').removeEventListener('click',this.hide)
        },
        initFocus(){
            setTimeout(() => {
                const input = document.getElementById('searchInput')
                input.focus()
            }, 200);
        }
    },
    mounted() {
        this.initFocus()
        this.listenEvent()
    },
    beforeDestroy() {
        this.removeEvent()
    }
}
</script>

<style lang="less" scoped>
.d-search-user {
    .triangle {
        position: absolute;
        bottom: -1PX;
        left: 13PX;
        width: 13PX;
        height: 7PX;
        z-index: 2;
    }
    .search-content {
        position: absolute;
        top: 36px;
        left: 0;
        width: 200PX;
        height: 240PX;
        overflow: hidden;
        background: #FFFFFF;
        box-shadow: 0PX 2PX 6PX 0PX rgba(0,0,0,0.06), 0PX 4PX 10PX -2PX rgba(0,0,0,0.07);
        border: 1PX solid rgba(0,0,0,0.02);
        box-sizing: border-box;
        z-index: 2;
    }

    .input-wrap {
        box-sizing: border-box;
        margin: 8PX 8PX 0PX 8PX;
        padding: 0PX 12PX 0PX 8PX;
        height: 28PX;
        background: #F5F6F7;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .search-icon {
            width: 14PX;
            height: 14PX;
            background: url('../../images/icon_search_999999@2x.png') no-repeat center;
            background-size: contain;
            flex-shrink: 0;
        }

        .delete-icon {
            width: 12PX;
            height: 12PX;
            background: url('../../images/icon_close_search@2x.png') no-repeat center;
            background-size: contain;
            flex-shrink: 0;
        }

        .search-input {
            flex: 1;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 13PX;
            color: #111111;
            line-height: 20PX;
            text-align: left;
            font-style: normal;
            margin-left: 12PX;
            background: transparent;
            border:0PX;
            outline: none;
            min-width: 0;
            &::-webkit-input-placeholder{
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 13PX;
                color: #999999;
                line-height: 20PX;
                text-align: left;
                font-style: normal;
            }
        }
    }

    .user-list {
        margin-top: 5PX;
        max-height: 200PX;
        overflow-y: auto;

        .user-item {
            box-sizing: border-box;
            height: 40PX;
            padding: 8PX 12PX;
            display: flex;
            align-items: center;
            overflow: hidden;
            &:hover {
                background: #F8F8F8;
            }
        }

        .avatar {
            margin-right: 8PX;
            flex-shrink: 0;
            width: 24PX;
            height: 24PX;
            border-radius: 50%;

            >img {
                width: 100%;
                border-radius: 50%;
            }
        }

        .user-content {
            flex: 1;
            display: flex;
            align-items: center;

            .name {
                font-weight: 400;
                font-size: 14px;
                color: #111111;
                line-height: 20px;
            }

            .tag {
                flex-shrink: 0;
                margin-left: 4PX;
                padding: 0 4PX;
                background: rgba(153,153,153,0.2);
                font-weight: 400;
                font-size: 12PX;
                color: #999999;
                line-height: 19PX;
            }
        }
    }

    .noData {
        margin-top: 26PX;
        display: flex;
        flex-direction: column;
        align-items: center;
        .empty-cover {
            width: 100PX;
            height: 100PX;
            background: url('../../images/empty_at_user.png') no-repeat center;
            background-size: contain;
        }

        .text {
            font-weight: 400;
            font-size: 14PX;
            color: #999999;
            line-height: 18PX;
            text-align: center;
            margin-top: 5PX;
        }
    }
}
</style>
<style lang="less">
.d-search-user .user-content .name .red-text {
    color: #F43640;
}
</style>